import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useTheme } from "@mui/material";
import logoPng from "../../assets/logo/LogoTest.png";

const TRUST_ORANGE = "#ff7a32"; // Color del escudo exacto

function AdminTrustLogo({ size = "md", iconOnly = false, subtitle = true, sx = {} }) {
  const theme = useTheme();
  const mode = theme.palette.mode;

  const map = {
    xs: { svg: 24, title: 16, gap: 0.75 },
    sm: { svg: 32, title: 18, gap: 1.25 },
    md: { svg: 62, title: 21, gap: 0.8 },
    // Sidenav expandido (escala desktop): misma proporción ícono/wordmark que md.
    nav: { svg: 50, title: 17.5, gap: 0.7, subtitle: 10.5 },
    lg: { svg: 56, title: 26, gap: 1.5 },
  };
  const dims = map[size] || map.md;

  const adminColor = mode === "dark" ? "rgba(255,255,255,0.92)" : "#111827";

  return (
    <Box display="flex" alignItems="center" gap={dims.gap} sx={sx}>
      {/* Ícono */}
      <Box
        component="img"
        src={logoPng}
        alt="AdminTrust logo"
        sx={{
          height: dims.svg,
          width: "auto",
          display: "block",
        }}
      />

      {/* Wordmark */}
      {!iconOnly && (
        <Box display="flex" flexDirection="column" >
          <Typography
            variant="h6"
            sx={{
              fontSize: dims.title,
              fontWeight: 800,
              lineHeight: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box component="span" sx={{ color: adminColor }}>Admin</Box>
            <Box component="span" sx={{ color: TRUST_ORANGE, ml: 0.5 }}>Trust</Box>
          </Typography>

          {subtitle && (
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                letterSpacing: 1.2,
                textTransform: "uppercase",
                fontWeight: 600,
                ...(dims.subtitle && { fontSize: dims.subtitle }),
              }}
            >
              Dashboard
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

AdminTrustLogo.propTypes = {
  size: PropTypes.oneOf(["xs", "sm", "md", "nav", "lg"]),
  iconOnly: PropTypes.bool,
  subtitle: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AdminTrustLogo;
